import { Component, Input, WritableSignal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { RouteFormDateSelectorService } from '../../services/route-form-date-selector.service';
import { CustomDateAdapter } from 'src/app/custom-date-adapter';

@Component({
  selector: 'app-date-option-form',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, NgxMatTimepickerModule, MatButtonToggleModule, TranslocoPipe, MatDatepickerModule, MatNativeDateModule, MatInputModule, FormsModule],
  templateUrl: './date-option-form.component.html',
  styleUrls: ['./date-option-form.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ]
  
})
export class DateOptionFormComponent {

  @Input({required: true}) dateField!: WritableSignal<Date>;
  @Input({required: true}) hourField!: WritableSignal<string>;
  @Input() disabled: boolean = false;

  private routeFormDateSelectorService = inject(RouteFormDateSelectorService)
  public currentHour = this.routeFormDateSelectorService.getMinHour();
  public minHour = computed( () => this.routeFormDateSelectorService.checkTwoDatesEqual(this.dateField(), new Date()) ? this.currentHour : '00:00');


  public currentDate = new Date();

  public dateFieldChanged(date:Date, hour:string) {
    this.dateField.set(date);
    this.hourField.set(this.routeFormDateSelectorService.checkHourValidity(date, hour) ?  hour : this.routeFormDateSelectorService.getCurrentHour());
  }

}
